export default "__VITE_ASSET__CNHL37H0__"